import { useRecoilValue } from 'recoil';

import { isDrawerOpen, drawerOption, isDrawerMenuOpen, drawerMenuOption } from './atoms';

export const useIsDrawerOpen = () => useRecoilValue(isDrawerOpen);

export const useDrawerOption = () => useRecoilValue(drawerOption);

export const useIsDrawerMenuOpen = () => useRecoilValue(isDrawerMenuOpen);

export const useDrawerMenuOption = () => useRecoilValue(drawerMenuOption);
